import type { SearchKey } from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';
import { type Event as MessageBusEvent, MessageBus } from '@podium/browser';
import { SearchParams } from './QueryKeys';

const MESSAGE_BUS_CHANNEL = 'search';
const MESSAGE_BUS_TOPIC = 'filters';

type SearchFiltersPayload = {
    searchKey: SearchKey;
    searchParams: SearchParams;
};

export function useSearchFilters(
    initialSearchKey: SearchKey,
    initialSearchParams: SearchParams,
) {
    const [searchKey, setSearchKey] = React.useState(initialSearchKey);
    const [searchParams, setSearchParams] = React.useState(initialSearchParams);

    React.useEffect(() => {
        function handleUpdatedFilters(ev: MessageBusEvent) {
            const payload = ev.payload as SearchFiltersPayload;
            setSearchKey(payload.searchKey);
            setSearchParams(payload.searchParams);
        }

        const messageBus = new MessageBus();
        messageBus.subscribe(
            MESSAGE_BUS_CHANNEL,
            MESSAGE_BUS_TOPIC,
            handleUpdatedFilters,
        );

        return () =>
            messageBus.unsubscribe(
                MESSAGE_BUS_CHANNEL,
                MESSAGE_BUS_TOPIC,
                handleUpdatedFilters,
            );
    }, []);

    return {
        searchKey,
        searchParams,
    };
}
